import { Signal } from '@preact/signals';
import { GameSettings } from './settings.models';

export enum GameContext {
  MAIN_MENU = 'main_menu',
  IN_MENU = 'in_menu',
  IN_GAME = 'in_game',
  SCENE_TRANSITION = 'scene_transition',
  CUTSCENE = 'cutscene',
  DIALOG = 'dialog',
  INVENTORY = 'inventory',
  BATTLE = 'battle',
}

export type GlobalStore<NewGameState, NewGameActions> = {
  state: GlobalGameState & NewGameState;
  actions: GameStateActions & NewGameActions;
  settings: Signal<GameSettings>;

  addGameState: <NewGameState, NewGameActions>(
    gameState: NewGameState,
    gameActions: NewGameActions
  ) => void;
};

export type GlobalGameState = {
  context: Signal<GameContext>;
  isPaused: Signal<boolean>;
  currentLevel: Signal<string>;
  globalVariables: Signal<Record<string, any>>;
};

export type InventoryItem = {
  id: string;
};

export type GameStateActions = {
  setSettings: (settings: Partial<GameSettings>) => void;
  saveSettings: () => void;
  setContext: (context: GameContext) => void;
  setGlobalVariables: (variables: Record<string, any>) => void;
  pauseGame: () => void;
  resumeGame: () => void;
  saveState: () => void;
  loadState: () => Promise<void>;
  setCurrentLevel: (name: string) => void;
  resetToInitialState: () => void;
};
